import React from 'react';

import MergeClassNames from 'utils/MergeClassNames';

interface LinkButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}

/** Text link that opens another view — the same look as the Category spend "Spend over time" link. */
const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  onClick,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={MergeClassNames(
      'w-fit cursor-pointer border-none bg-transparent p-0 text-sm font-semibold text-primary underline hover:text-primary-dark',
      className
    )}
  >
    {children}
  </button>
);

export default LinkButton;
